import React from 'react';
import { ConfigProvider, Empty, Layout } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import { brand } from './branding';

const { Content } = Layout;

const App: React.FC = () => {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: brand.colors.primary, colorLink: brand.colors.secondary } }}>
      <Layout>
        <Router>
          <Routes>
            <Route path="/:code" element={<Home />} />
            <Route path="/" element={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '650px' }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>} />
          </Routes>
        </Router>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
